import {
  Kaaba1Icon,
  KaabaSelectedIcon,
  Mosque2Icon,
  MosqueMadinaSelectedIcon,
  UserSearch1Icon,
  UserSerachSelectedIcon,
  UserUnlockSelectedIcon,
  UserUnlock01Icon,
} from "@/assets/icons";
import { generatePermissionName } from "./permissions";

export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
export const TIME_FORMAT_12_HOURS = "hh:mm a";
export const DATE_TIME_FORMAT = "DD - MMMM YYYY HH:mm";
export const DATE_TIME_FORMAT_12_HOURS = "DD - MMMM YYYY hh:mm a";

export const DATE_TIME_FORMAT_INPUT = "YYYY-MM-DD HH:mm";

export const SYSTEMS = {
  makkah: "makkah",
  madina: "madina",
  user_management: "user_management",
  seasonal_hr: "seasonal_hr",
};


export const EXAMINATION_TYPES = {
  normal: "normal",
  track: "track",
  complaint: "complaint",
};

export const ORDER_STATUS = {
  not_created: "not_created",
  in_progress: "in_progress",
  completed: "completed",
  cancelled: "cancelled",
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  expired: "expired",
};

export const EXAMINATION_RESULT_STATUS = {
  qualified: "qualified",
  not_qualified: "not_qualified",
};

export const PLATFORMS = {
  makkah: {
    icon: <Kaaba1Icon />,
    selectedIcon: <KaabaSelectedIcon />,
    name: "DROPDOWN_MAKKAH_PLATFORM",
    path: "/app/makkah",
    system_id: 1,
    key: "makkah",
  },

  madina: {
    icon: <Mosque2Icon />,
    selectedIcon: <MosqueMadinaSelectedIcon />,
    name: "DROPDOWN_MADINAH_PLATFORM",
    path: "/app/madina",
    system_id: 2,
    key: "madina",
  },

  seasonal_hr: {
    icon: <UserSearch1Icon />,
    selectedIcon: <UserSerachSelectedIcon />,
    name: "DROPDOWN_SEASONAL_RECRUITMENT_PLATFORM",
    path: "/app/seasonal_hr",
    system_id: 3,
    key: "seasonal_hr",
  },

  user_management: {
    icon: <UserUnlock01Icon />,
    selectedIcon: <UserUnlockSelectedIcon />,
    name: "DROPDOWN_USERS_MANAGEMENT_PLATFORM",
    path: "/app/user_management/users",
    system_id: 4,
    key: "user_management",
  },
};

export const CITIES = {
  makkah: {
    id: 3,
    name: "Makkah",
  },
  madina: {
    id: 4,
    name: "Madina",
  },
};

export const MED_RECEPTION_TABS = {
  today: {
    key: "today",
    label: "TODAY",
  },
  all: {
    key: "all",
    label: "ALL",
  },
};

export const NUSUK_CITY_ID = {
  makkah: 603,
  madina: 605,
};



export const MODES = {
  edit: "edit",
  view: "view",
  create: "create",
}

export const REFRESH_INTERVAL = 1000 * 60 * 10;


export const PILGRIM_STATUS = [
  {
    "key": "not_arrived",
    "label_ar": "غير موجود او لم يصل",
    "label_en": "Not arrived",
    "color": "yellow"
  },
  {
    "key": "exist",
    "label_ar": "موجود",
    "label_en": "Exist",
    "color": "green"
  },
  {
    "key": "departed",
    "label_ar": "مغادر",
    "label_en": "Departed",
    "color": "red"
  },
  {
    "key": "deceased",
    "label_ar": "متوفي",
    "label_en": "Deceased",
    "color": "black"
  }
]


const pdfMimeType = "application/pdf"
const excelMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

export const MIME_TYPES = {
  pdf: pdfMimeType,
  excel: excelMimeType,
  json: "application/json",
}

export const ROLES = {
  super_admin: "super_admin",
}





export const MAKKAH_PERMISSIONS = {
  list_users_for_makkah: "list_users",
  create_user_for_makkah: "create_user",
  update_user_for_makkah: "update_user",
  delete_user_for_makkah: "delete_user",
  reset_user_password_for_makkah: "reset_user_password",
  update_user_status_for_makkah: "update_user_status",
  upload_user_profile_image_for_makkah: "upload_user_profile_image",
  assign_user_permissions_for_makkah: "assign_user_permissions",
  assign_user_groups_for_makkah: "assign_user_groups",
  list_groups_for_makkah: "list_groups",
  create_group_for_makkah: "create_group",
  update_group_for_makkah: "update_group",
  delete_group_for_makkah: "delete_group",
  assign_group_for_makkah: "assign_group",
  assign_group_permissions_for_makkah: "assign_group_permissions",
  list_permissions_for_makkah: "list_permissions",
  create_permission_for_makkah: "create_permission",
  update_permission_for_makkah: "update_permission",
  delete_permission_for_makkah: "delete_permission",
  assign_permission_for_makkah: "assign_permission",
  assign_system_for_makkah: "assign_system",
  list_systems_for_makkah: "list_systems",
  assign_role_for_makkah: "assign_role",
  list_housing: "list_housing",
  view_housing_details: "view_housing_details",
  edit_housing_data: "edit_housing_data",
  evacuate_housing: "evacuate_housing",
  list_housing_contracts: "list_housing_contracts",
  view_housing_contract_details: "view_housing_contract_details",
  list_house_inspection_examinations: "list_house_inspection_examinations",
  list_house_inspection_orders: "list_house_inspection_orders",
  start_house_inspection_follow_up: "start_house_inspection_follow_up",
  start_house_inspection_order: "start_house_inspection_order",
  create_house_inspection_order: "create_house_inspection_order",
  re_inspect_house_inspection: "re_inspect_house_inspection",
  edit_house_inspection_order: "edit_house_inspection_order",
  delete_house_inspection_order: "delete_house_inspection_order",
  complete_house_inspection_order: "complete_house_inspection_order",
  view_house_inspection_results: "view_house_inspection_results",
  view_house_inspection_requests_reports: "view_house_inspection_requests_reports",
  list_house_inspection_examination_periods: "list_house_inspection_examination_periods",
  create_house_inspection_examination_periods: "create_house_inspection_examination_periods",
  edit_house_inspection_examination_periods: "edit_house_inspection_examination_periods",
  delete_house_inspection_examination_periods: "delete_house_inspection_examination_periods",
  list_house_inspection_groups: "list_house_inspection_groups",
  create_house_inspection_groups: "create_house_inspection_groups",
  edit_house_inspection_groups: "edit_house_inspection_groups",
  delete_house_inspection_groups: "delete_house_inspection_groups",
  list_house_inspection_items: "list_house_inspection_items",
  create_house_inspection_items: "create_house_inspection_items",
  edit_house_inspection_items: "edit_house_inspection_items",
  delete_house_inspection_items: "delete_house_inspection_items",
  list_house_inspection_period_codes: "list_house_inspection_period_codes",
  create_house_inspection_period_codes: "create_house_inspection_period_codes",
  edit_house_inspection_period_codes: "edit_house_inspection_period_codes",
  delete_house_inspection_period_codes: "delete_house_inspection_period_codes",
  manage_house_inspection_period_code_users: "manage_house_inspection_period_code_users",
  view_planning: "view_planning",
  view_organizers: "view_organizers",
  list_basic_packages: "list_basic_packages",
  view_basic_packages: "view_basic_packages",
  view_visas: "view_visas",
  list_pilgrim_visas: "list_pilgrim_visas",
  list_campaigns: "list_campaigns",
  view_campaigns: "view_campaigns",
  create_campaigns: "create_campaigns",
  update_campaigns: "update_campaigns",
  delete_campaigns: "delete_campaigns",
  import_campaigns: "import_campaigns",
  list_campaign_details: "list_campaign_details",
  view_campaign_details: "view_campaign_details",
  create_campaign_details: "create_campaign_details",
  update_campaign_details: "update_campaign_details",
  delete_campaign_details: "delete_campaign_details",
  list_groups: "list_groups",
  view_groups: "view_groups",
  create_groups: "create_groups",
  update_groups: "update_groups",
  delete_groups: "delete_groups",
  list_group_details: "list_group_details",
  view_group_details: "view_group_details",
  create_group_details: "create_group_details",
  update_group_details: "update_group_details",
  delete_group_details: "delete_group_details",
  view_camps: "view_camps",
  view_compliance: "view_compliance",
  view_dashboard_summary_makkah: "view_dashboard_summary_makkah",
  view_dashboard_sections_makkah: "view_dashboard_sections_makkah",
  list_port_reception_cards_from_missions: "list_port_reception_cards_from_missions",
  control_port_reception_cards_from_missions: "control_port_reception_cards_from_missions",
  list_port_reception_cards_from_nask: "list_port_reception_cards_from_nask",
  controle_port_reception_cards_from_nusk: "controle_port_reception_cards_from_nusk",
  list_center_reception_cards_from_ports: "list_center_reception_cards_from_ports",
  control_center_reception_cards_from_ports: "control_center_reception_cards_from_ports",
  list_center_reception_cards_between_cities: "list_center_reception_cards_between_cities",
  control_center_reception_cards_between_cities: "control_center_reception_cards_between_cities",
  list_makkah_reception_manifests: "list_makkah_reception_manifests",
  list_makkah_reception_manifest_pilgrims: "list_makkah_reception_manifest_pilgrims",
  list_makkah_reception_tafweejs: "list_makkah_reception_tafweejs",
  list_makkah_reception_tafweej_pilgrims: "list_makkah_reception_tafweej_pilgrims",
  list_pilgrim_data: "list_pilgrim_data",
  list_makkah_group_pilgrims_inquiry: "list_makkah_group_pilgrims_inquiry",
  control_pilgrim_data: "control_pilgrim_data",
  assign_pilgrim_accommodation: "assign_pilgrim_accommodation",
  cancel_pilgrim_accommodation: "cancel_pilgrim_accommodation",
  view_accommodations: "view_accommodations",
  view_export_housing_contract_detail_report: "view_export_housing_contract_detail_report",
  view_export_housing_comprehensive_detail_report: "view_export_housing_comprehensive_detail_report",
  view_export_housing_building_delegate_detail_report: "view_export_housing_building_delegate_detail_report",
  view_export_campaign_group_pilgrims_report: "view_export_campaign_group_pilgrims_report",
  view_pilgrim_report_not_coming_makkah: "view_pilgrim_report_not_coming_makkah",
  view_pilgrim_report_not_accommodated_makkah: "view_pilgrim_report_not_accommodated_makkah",
  view_pilgrim_report_nationality_stats_makkah: "view_pilgrim_report_nationality_stats_makkah",
  view_pilgrim_report_mission_stats_makkah: "view_pilgrim_report_mission_stats_makkah",
  list_makkah_incident_reports: "list_makkah_incident_reports",
  create_makkah_incident_reports: "create_makkah_incident_reports",
  update_makkah_incident_reports: "update_makkah_incident_reports",
  delete_makkah_incident_reports: "delete_makkah_incident_reports",
  view_makkah_incident_reports_details: "view_makkah_incident_reports_details",
  search_pilgrims_for_makkah_incident_reports: "search_pilgrims_for_makkah_incident_reports",
  view_export_makkah_incident_reports_report: "view_export_makkah_incident_reports_report",
  makkah_view_export_incident_reports: "makkah_view_export_incident_reports",
  view_export_makkah_arrival_campaign_segments_report: "view_export_makkah_arrival_campaign_segments_report",
  view_export_makkah_group_details_report: "view_export_makkah_group_details_report",
  view_export_makkah_housed_arrivals_service_center_distribution_report: "view_export_makkah_housed_arrivals_service_center_distribution_report",
  view_export_makkah_campaign_statement_report: "view_export_makkah_campaign_statement_report",
  view_export_makkah_group_statement_report: "view_export_makkah_group_statement_report",
  list_nusuk_cards_batchs: "list_nusuk_cards_batchs_madina",
  view_nusuk_cards_batchs: "view_nusuk_cards_batchs_madina",
  create_nusuk_cards_batchs: "create_nusuk_cards_batchs_madina",
  update_nusuk_cards_batchs: "update_nusuk_cards_batchs_madina",
  delete_nusuk_cards_batchs: "delete_nusuk_cards_batchs_madina",
  change_delivery_status_nusuk_cards_batchs: "change_delivery_status_nusuk_cards_batchs_madina",
  list_nusuk_cards_batch_returns: "list_nusuk_cards_batch_returns_madina",
  create_nusuk_cards_batch_returns: "create_nusuk_cards_batch_returns_madina",
  update_nusuk_cards_batch_returns: "update_nusuk_cards_batch_returns_madina",
  delete_nusuk_cards_batch_returns: "delete_nusuk_cards_batch_returns_madina",
  view_export_nusuk_cards_batch_report: "view_export_nusuk_cards_batch_report_madina",
  list_nusuk_cards_batchs_incident_reports: "list_nusuk_cards_batchs_incident_reports_madina",
  resolve_nusuk_cards_batchs_incident_reports: "resolve_nusuk_cards_batchs_incident_reports_madina",
}
export const MAKKAH_PERMISSIONS_FULL_NAMES = {
  list_users_for_makkah: generatePermissionName(1, "list_users"),
  create_user_for_makkah: generatePermissionName(1, "create_user"),
  update_user_for_makkah: generatePermissionName(1, "update_user"),
  delete_user_for_makkah: generatePermissionName(1, "delete_user"),
  reset_user_password_for_makkah: generatePermissionName(1, "reset_user_password"),
  update_user_status_for_makkah: generatePermissionName(1, "update_user_status"),
  upload_user_profile_image_for_makkah: generatePermissionName(1, "upload_user_profile_image"),
  assign_user_permissions_for_makkah: generatePermissionName(1, "assign_user_permissions"),
  assign_user_groups_for_makkah: generatePermissionName(1, "assign_user_groups"),
  list_groups_for_makkah: generatePermissionName(1, "list_groups"),
  create_group_for_makkah: generatePermissionName(1, "create_group"),
  update_group_for_makkah: generatePermissionName(1, "update_group"),
  delete_group_for_makkah: generatePermissionName(1, "delete_group"),
  assign_group_for_makkah: generatePermissionName(1, "assign_group"),
  assign_group_permissions_for_makkah: generatePermissionName(1, "assign_group_permissions"),
  list_permissions_for_makkah: generatePermissionName(1, "list_permissions"),
  create_permission_for_makkah: generatePermissionName(1, "create_permission"),
  update_permission_for_makkah: generatePermissionName(1, "update_permission"),
  delete_permission_for_makkah: generatePermissionName(1, "delete_permission"),
  assign_permission_for_makkah: generatePermissionName(1, "assign_permission"),
  assign_system_for_makkah: generatePermissionName(1, "assign_system"),
  list_systems_for_makkah: generatePermissionName(1, "list_systems"),
  assign_role_for_makkah: generatePermissionName(1, "assign_role"),
  list_housing: generatePermissionName(1, "list_housing"),
  view_housing_details: generatePermissionName(1, "view_housing_details"),
  edit_housing_data: generatePermissionName(1, "edit_housing_data"),
  evacuate_housing: generatePermissionName(1, "evacuate_housing"),
  list_housing_contracts: generatePermissionName(1, "list_housing_contracts"),
  view_housing_contract_details: generatePermissionName(1, "view_housing_contract_details"),
  list_house_inspection_examinations: generatePermissionName(1, "list_house_inspection_examinations"),
  list_house_inspection_orders: generatePermissionName(1, "list_house_inspection_orders"),
  start_house_inspection_follow_up: generatePermissionName(1, "start_house_inspection_follow_up"),
  start_house_inspection_order: generatePermissionName(1, "start_house_inspection_order"),
  create_house_inspection_order: generatePermissionName(1, "create_house_inspection_order"),
  re_inspect_house_inspection: generatePermissionName(1, "re_inspect_house_inspection"),
  edit_house_inspection_order: generatePermissionName(1, "edit_house_inspection_order"),
  delete_house_inspection_order: generatePermissionName(1, "delete_house_inspection_order"),
  complete_house_inspection_order: generatePermissionName(1, "complete_house_inspection_order"),
  view_house_inspection_results: generatePermissionName(1, "view_house_inspection_results"),
  view_house_inspection_requests_reports: generatePermissionName(1, "view_house_inspection_requests_reports"),
  list_house_inspection_examination_periods: generatePermissionName(1, "list_house_inspection_examination_periods"),
  create_house_inspection_examination_periods: generatePermissionName(1, "create_house_inspection_examination_periods"),
  edit_house_inspection_examination_periods: generatePermissionName(1, "edit_house_inspection_examination_periods"),
  delete_house_inspection_examination_periods: generatePermissionName(1, "delete_house_inspection_examination_periods"),
  list_house_inspection_groups: generatePermissionName(1, "list_house_inspection_groups"),
  create_house_inspection_groups: generatePermissionName(1, "create_house_inspection_groups"),
  edit_house_inspection_groups: generatePermissionName(1, "edit_house_inspection_groups"),
  delete_house_inspection_groups: generatePermissionName(1, "delete_house_inspection_groups"),
  list_house_inspection_items: generatePermissionName(1, "list_house_inspection_items"),
  create_house_inspection_items: generatePermissionName(1, "create_house_inspection_items"),
  edit_house_inspection_items: generatePermissionName(1, "edit_house_inspection_items"),
  delete_house_inspection_items: generatePermissionName(1, "delete_house_inspection_items"),
  list_house_inspection_period_codes: generatePermissionName(1, "list_house_inspection_period_codes"),
  create_house_inspection_period_codes: generatePermissionName(1, "create_house_inspection_period_codes"),
  edit_house_inspection_period_codes: generatePermissionName(1, "edit_house_inspection_period_codes"),
  delete_house_inspection_period_codes: generatePermissionName(1, "delete_house_inspection_period_codes"),
  manage_house_inspection_period_code_users: generatePermissionName(1, "manage_house_inspection_period_code_users"),
  view_planning: generatePermissionName(1, "view_planning"),
  view_organizers: generatePermissionName(1, "view_organizers"),
  list_basic_packages: generatePermissionName(1, "list_basic_packages"),
  view_basic_packages: generatePermissionName(1, "view_basic_packages"),
  view_visas: generatePermissionName(1, "view_visas"),
  list_pilgrim_visas: generatePermissionName(1, "list_pilgrim_visas"),
  list_campaigns: generatePermissionName(1, "list_campaigns"),
  view_campaigns: generatePermissionName(1, "view_campaigns"),
  create_campaigns: generatePermissionName(1, "create_campaigns"),
  update_campaigns: generatePermissionName(1, "update_campaigns"),
  delete_campaigns: generatePermissionName(1, "delete_campaigns"),
  import_campaigns: generatePermissionName(1, "import_campaigns"),
  list_campaign_details: generatePermissionName(1, "list_campaign_details"),
  view_campaign_details: generatePermissionName(1, "view_campaign_details"),
  create_campaign_details: generatePermissionName(1, "create_campaign_details"),
  update_campaign_details: generatePermissionName(1, "update_campaign_details"),
  delete_campaign_details: generatePermissionName(1, "delete_campaign_details"),
  list_groups: generatePermissionName(1, "list_groups"),
  view_groups: generatePermissionName(1, "view_groups"),
  create_groups: generatePermissionName(1, "create_groups"),
  update_groups: generatePermissionName(1, "update_groups"),
  delete_groups: generatePermissionName(1, "delete_groups"),
  list_group_details: generatePermissionName(1, "list_group_details"),
  view_group_details: generatePermissionName(1, "view_group_details"),
  create_group_details: generatePermissionName(1, "create_group_details"),
  update_group_details: generatePermissionName(1, "update_group_details"),
  delete_group_details: generatePermissionName(1, "delete_group_details"),
  view_camps: generatePermissionName(1, "view_camps"),
  view_compliance: generatePermissionName(1, "view_compliance"),
  view_dashboard_summary_makkah: generatePermissionName(1, "view_dashboard_summary_makkah"),
  view_dashboard_sections_makkah: generatePermissionName(1, "view_dashboard_sections_makkah"),
  list_port_reception_cards_from_missions: generatePermissionName(1, "list_port_reception_cards_from_missions"),
  control_port_reception_cards_from_missions: generatePermissionName(1, "control_port_reception_cards_from_missions"),
  list_port_reception_cards_from_nask: generatePermissionName(1, "list_port_reception_cards_from_nask"),
  controle_port_reception_cards_from_nusk: generatePermissionName(1, "controle_port_reception_cards_from_nusk"),
  list_center_reception_cards_from_ports: generatePermissionName(1, "list_center_reception_cards_from_ports"),
  control_center_reception_cards_from_ports: generatePermissionName(1, "control_center_reception_cards_from_ports"),
  list_center_reception_cards_between_cities: generatePermissionName(1, "list_center_reception_cards_between_cities"),
  control_center_reception_cards_between_cities: generatePermissionName(1, "control_center_reception_cards_between_cities"),
  list_makkah_reception_manifests: generatePermissionName(1, "list_makkah_reception_manifests"),
  list_makkah_reception_manifest_pilgrims: generatePermissionName(1, "list_makkah_reception_manifest_pilgrims"),
  list_makkah_reception_tafweejs: generatePermissionName(1, "list_makkah_reception_tafweejs"),
  list_makkah_reception_tafweej_pilgrims: generatePermissionName(1, "list_makkah_reception_tafweej_pilgrims"),
  list_pilgrim_data: generatePermissionName(1, "list_pilgrim_data"),
  list_makkah_group_pilgrims_inquiry: generatePermissionName(1, "list_makkah_group_pilgrims_inquiry"),
  control_pilgrim_data: generatePermissionName(1, "control_pilgrim_data"),
  assign_pilgrim_accommodation: generatePermissionName(1, "assign_pilgrim_accommodation"),
  cancel_pilgrim_accommodation: generatePermissionName(1, "cancel_pilgrim_accommodation"),
  view_accommodations: generatePermissionName(1, "view_accommodations"),
  view_export_housing_contract_detail_report: generatePermissionName(1, "view_export_housing_contract_detail_report"),
  view_export_house_contract_campaigns_report: generatePermissionName(1, "view_export_house_contract_campaigns_report"),
  view_export_food_contracts_report: generatePermissionName(1, "view_export_food_contracts_report"),
  view_export_housing_comprehensive_detail_report: generatePermissionName(1, "view_export_housing_comprehensive_detail_report"),
  view_export_housing_building_delegate_detail_report: generatePermissionName(1, "view_export_housing_building_delegate_detail_report"),
  view_export_campaign_group_pilgrims_report: generatePermissionName(1, "view_export_campaign_group_pilgrims_report"),
  view_pilgrim_report_not_coming_makkah: generatePermissionName(1, "view_pilgrim_report_not_coming_makkah"),
  view_pilgrim_report_not_accommodated_makkah: generatePermissionName(1, "view_pilgrim_report_not_accommodated_makkah"),
  view_pilgrim_report_nationality_stats_makkah: generatePermissionName(1, "view_pilgrim_report_nationality_stats_makkah"),
  view_pilgrim_report_mission_stats_makkah: generatePermissionName(1, "view_pilgrim_report_mission_stats_makkah"),
  list_makkah_incident_reports: generatePermissionName(1, "list_makkah_incident_reports"),
  create_makkah_incident_reports: generatePermissionName(1, "create_makkah_incident_reports"),
  update_makkah_incident_reports: generatePermissionName(1, "update_makkah_incident_reports"),
  delete_makkah_incident_reports: generatePermissionName(1, "delete_makkah_incident_reports"),
  view_makkah_incident_reports_details: generatePermissionName(1, "view_makkah_incident_reports_details"),
  search_pilgrims_for_makkah_incident_reports: generatePermissionName(1, "search_pilgrims_for_makkah_incident_reports"),
  view_export_makkah_incident_reports_report: generatePermissionName(1, "view_export_makkah_incident_reports_report"),
  makkah_view_export_incident_reports: generatePermissionName(1, "makkah_view_export_incident_reports"),
  view_export_makkah_arrival_campaign_segments_report: generatePermissionName(1, "view_export_makkah_arrival_campaign_segments_report"),
  view_export_makkah_group_details_report: generatePermissionName(1, "view_export_makkah_group_details_report"),
  view_export_makkah_housed_arrivals_service_center_distribution_report: generatePermissionName(1, "view_export_makkah_housed_arrivals_service_center_distribution_report"),
  view_export_makkah_campaign_statement_report: generatePermissionName(1, "view_export_makkah_campaign_statement_report"),
  view_export_makkah_group_statement_report: generatePermissionName(1, "view_export_makkah_group_statement_report"),
  view_export_arrival_campaign_segments_report: generatePermissionName(1, "view_export_makkah_arrival_campaign_segments_report"),
  view_export_group_details_report: generatePermissionName(1, "view_export_makkah_group_details_report"),
  view_export_housed_arrivals_service_center_distribution_report: generatePermissionName(1, "view_export_makkah_housed_arrivals_service_center_distribution_report"),
  view_export_campaign_statement_report: generatePermissionName(1, "view_export_makkah_campaign_statement_report"),
  view_export_group_statement_report: generatePermissionName(1, "view_export_makkah_group_statement_report"),
  list_nusuk_cards_batchs: generatePermissionName(1, "list_nusuk_cards_batchs"),
  view_nusuk_cards_batchs: generatePermissionName(1, "view_nusuk_cards_batchs"),
  create_nusuk_cards_batchs: generatePermissionName(1, "create_nusuk_cards_batchs"),
  update_nusuk_cards_batchs: generatePermissionName(1, "update_nusuk_cards_batchs"),
  delete_nusuk_cards_batchs: generatePermissionName(1, "delete_nusuk_cards_batchs"),
  change_delivery_status_nusuk_cards_batchs: generatePermissionName(1, "change_delivery_status_nusuk_cards_batchs"),
  list_nusuk_cards_batch_returns: generatePermissionName(1, "list_nusuk_cards_batch_returns"),
  create_nusuk_cards_batch_returns: generatePermissionName(1, "create_nusuk_cards_batch_returns"),
  update_nusuk_cards_batch_returns: generatePermissionName(1, "update_nusuk_cards_batch_returns"),
  delete_nusuk_cards_batch_returns: generatePermissionName(1, "delete_nusuk_cards_batch_returns"),
  view_export_nusuk_cards_batch_report: generatePermissionName(1, "view_export_nusuk_cards_batch_report"),
  list_nusuk_cards_batchs_incident_reports: generatePermissionName(1, "list_nusuk_cards_batchs_incident_reports"),
  resolve_nusuk_cards_batchs_incident_reports: generatePermissionName(1, "resolve_nusuk_cards_batchs_incident_reports"),
}

export const MADINAH_PERMISSIONS = {
  list_users_for_madinah: "list_users",
  create_user_for_madinah: "create_user",
  update_user_for_madinah: "update_user",
  delete_user_for_madinah: "delete_user",
  reset_user_password_for_madinah: "reset_user_password",
  update_user_status_for_madinah: "update_user_status",
  upload_user_profile_image_for_madinah: "upload_user_profile_image",
  assign_user_permissions_for_madinah: "assign_user_permissions",
  assign_user_groups_for_madinah: "assign_user_groups",
  list_groups_for_madinah: "list_groups",
  create_group_for_madinah: "create_group",
  update_group_for_madinah: "update_group",
  delete_group_for_madinah: "delete_group",
  assign_group_for_madinah: "assign_group",
  assign_group_permissions_for_madinah: "assign_group_permissions",
  list_permissions_for_madinah: "list_permissions",
  create_permission_for_madinah: "create_permission",
  update_permission_for_madinah: "update_permission",
  delete_permission_for_madinah: "delete_permission",
  assign_permission_for_madinah: "assign_permission",
  assign_system_for_madinah: "assign_system",
  list_systems_for_madinah: "list_systems",
  assign_role_for_madinah: "assign_role",
  list_port_reception_cards_from_nusk_for_madina_for_madinah: "list_port_reception_cards_from_nusk",
  manage_port_reception_cards_from_nusk_for_madina_for_madinah: "manage_port_reception_cards_from_nusk",
  list_madina_arrival_bags_for_madinah: "list_madina_arrival_bags",
  manage_madina_arrival_bags_for_madinah: "manage_madina_arrival_bags",
  create_madina_arrival_reports_for_madinah: "create_madina_arrival_reports",
  update_madina_arrival_reports_for_madinah: "update_madina_arrival_reports",
  delete_madina_arrival_reports_for_madinah: "delete_madina_arrival_reports",
  view_dashboard_summary_madina: "view_dashboard_summary_madina",
  view_dashboard_sections_madina: "view_dashboard_sections_madina",
  list_port_reception_cards_from_nusk_for_madina: "list_port_reception_cards_from_nusk",
  manage_port_reception_cards_from_nusk_for_madina: "manage_port_reception_cards_from_nusk",
  list_madina_arrival_bags: "list_madina_arrival_bags",
  manage_madina_arrival_bags: "manage_madina_arrival_bags",
    create_madina_arrival_bags: "create_madina_arrival_bags",
    update_madina_arrival_bags: "update_madina_arrival_bags",
    delete_madina_arrival_bags: "delete_madina_arrival_bags",
    create_madina_arrival_reports: "create_madina_arrival_reports",
    view_export_housing_comprehensive_detail_report: "view_export_housing_comprehensive_detail_report",
    view_export_housing_building_delegate_detail_report: "view_export_housing_building_delegate_detail_report",
    view_export_housing_comprehensive_detail_report_for_madina: "view_export_housing_comprehensive_detail_report",
    view_export_housing_building_delegate_detail_report_for_madina: "view_export_housing_building_delegate_detail_report",
  update_madina_arrival_reports: "update_madina_arrival_reports",
  delete_madina_arrival_reports: "delete_madina_arrival_reports",
  list_madina_reception_manifests: "list_madina_reception_manifests",
  view_madina_reception_manifest: "view_madina_reception_manifest",
  update_madina_reception_manifest_bag_number: "update_madina_reception_manifest_bag_number",
  set_madina_reception_manifest_arrive_time: "set_madina_reception_manifest_arrive_time",
  cancel_madina_reception_manifest_arrival: "cancel_madina_reception_manifest_arrival",
  list_madina_reception_manifest_pilgrims: "list_madina_reception_manifest_pilgrims",
  accommodate_madina_reception_manifest_pilgrims: "accommodate_madina_reception_manifest_pilgrims",
  list_madina_reception_manifest_bag_details: "list_madina_reception_manifest_bag_details",
  create_madina_reception_manifest_bag_detail: "create_madina_reception_manifest_bag_detail",
  update_madina_reception_manifest_bag_detail: "update_madina_reception_manifest_bag_detail",
  delete_madina_reception_manifest_bag_detail: "delete_madina_reception_manifest_bag_detail",
  list_madina_reception_tafweejs: "list_madina_reception_tafweejs",
  update_madina_reception_tafweej_bag_number: "update_madina_reception_tafweej_bag_number",
  set_madina_reception_tafweej_arrive_time: "set_madina_reception_tafweej_arrive_time",
  cancel_madina_reception_tafweej_arrival: "cancel_madina_reception_tafweej_arrival",
  list_madina_reception_tafweej_pilgrims: "list_madina_reception_tafweej_pilgrims",
  accommodate_madina_reception_tafweej_pilgrims: "accommodate_madina_reception_tafweej_pilgrims",
  list_madina_reception_tafweej_bag_details: "list_madina_reception_tafweej_bag_details",
  delete_madina_reception_tafweej_bag_detail: "delete_madina_reception_tafweej_bag_detail",
  view_pilgrim_report_not_coming_madina: "view_pilgrim_report_not_coming_madina",
  view_pilgrim_report_not_accommodated_madina: "view_pilgrim_report_not_accommodated_madina",
  view_export_arrival_campaign_segments_report: "view_export_madina_arrival_campaign_segments_report",
  view_export_group_details_report: "view_export_madina_group_details_report",
  view_export_housed_arrivals_service_center_distribution_report: "view_export_madina_housed_arrivals_service_center_distribution_report",
  view_export_campaign_statement_report: "view_export_madina_campaign_statement_report",
  view_export_group_statement_report: "view_export_madina_group_statement_report",
  list_madina_arrival_campaigns: "list_madina_arrival_campaigns",
  view_madina_arrival_campaigns: "view_madina_arrival_campaigns",
  create_madina_arrival_campaigns: "create_madina_arrival_campaigns",
  update_madina_arrival_campaigns: "update_madina_arrival_campaigns",
  delete_madina_arrival_campaigns: "delete_madina_arrival_campaigns",
  list_madina_arrival_segments: "list_madina_arrival_segments",
  view_madina_arrival_segments: "view_madina_arrival_segments",
  create_madina_arrival_segments: "create_madina_arrival_segments",
  update_madina_arrival_segments: "update_madina_arrival_segments",
  delete_madina_arrival_segments: "delete_madina_arrival_segments",
  list_madina_groups: "list_madina_groups",
  view_madina_groups: "view_madina_groups",
  create_madina_groups: "create_madina_groups",
  update_madina_groups: "update_madina_groups",
  delete_madina_groups: "delete_madina_groups",
  list_madina_group_details: "list_madina_group_details",
  view_madina_group_details: "view_madina_group_details",
  create_madina_group_details: "create_madina_group_details",
  update_madina_group_details: "update_madina_group_details",
  delete_madina_group_details: "delete_madina_group_details",
  assign_pilgrim_accommodation_madina: "assign_pilgrim_accommodation_madina",
  cancel_pilgrim_accommodation_madina: "cancel_pilgrim_accommodation_madina",
  view_accommodations_madina: "view_accommodations_madina",
  list_madina_incident_reports: "list_madina_incident_reports",
  create_madina_incident_reports: "create_madina_incident_reports",
  update_madina_incident_reports: "update_madina_incident_reports",
  delete_madina_incident_reports: "delete_madina_incident_reports",
  view_madina_incident_reports_details: "view_madina_incident_reports_details",
  search_pilgrims_for_madina_incident_reports: "search_pilgrims_incident_reports",
  view_export_madina_incident_reports_report: "view_export_madina_incident_reports_report",
  madina_view_export_incident_reports: "madina_view_export_incident_reports",
  list_nusuk_cards_batchs: "list_nusuk_cards_batchs",
  view_nusuk_cards_batchs: "view_nusuk_cards_batchs",
  create_nusuk_cards_batchs: "create_nusuk_cards_batchs",
  update_nusuk_cards_batchs: "update_nusuk_cards_batchs",
  delete_nusuk_cards_batchs: "delete_nusuk_cards_batchs",
  change_delivery_status_nusuk_cards_batchs: "change_delivery_status_nusuk_cards_batchs",
  list_nusuk_cards_batch_returns: "list_nusuk_cards_batch_returns",
  create_nusuk_cards_batch_returns: "create_nusuk_cards_batch_returns",
  update_nusuk_cards_batch_returns: "update_nusuk_cards_batch_returns",
  delete_nusuk_cards_batch_returns: "delete_nusuk_cards_batch_returns",
  view_export_nusuk_cards_batch_report: "view_export_nusuk_cards_batch_report",
  list_nusuk_cards_batchs_incident_reports: "list_nusuk_cards_batchs_incident_reports",
  resolve_nusuk_cards_batchs_incident_reports: "resolve_nusuk_cards_batchs_incident_reports",
};
export const MADINAH_PERMISSIONS_FULL_NAMES = {
  list_users_for_madinah: generatePermissionName(2, "list_users"),
  create_user_for_madinah: generatePermissionName(2, "create_user"),
  update_user_for_madinah: generatePermissionName(2, "update_user"),
  delete_user_for_madinah: generatePermissionName(2, "delete_user"),
  reset_user_password_for_madinah: generatePermissionName(2, "reset_user_password"),
  update_user_status_for_madinah: generatePermissionName(2, "update_user_status"),
  upload_user_profile_image_for_madinah: generatePermissionName(2, "upload_user_profile_image"),
  assign_user_permissions_for_madinah: generatePermissionName(2, "assign_user_permissions"),
  assign_user_groups_for_madinah: generatePermissionName(2, "assign_user_groups"),
  list_groups_for_madinah: generatePermissionName(2, "list_groups"),
  create_group_for_madinah: generatePermissionName(2, "create_group"),
  update_group_for_madinah: generatePermissionName(2, "update_group"),
  delete_group_for_madinah: generatePermissionName(2, "delete_group"),
  assign_group_for_madinah: generatePermissionName(2, "assign_group"),
  assign_group_permissions_for_madinah: generatePermissionName(2, "assign_group_permissions"),
  list_permissions_for_madinah: generatePermissionName(2, "list_permissions"),
  create_permission_for_madinah: generatePermissionName(2, "create_permission"),
  update_permission_for_madinah: generatePermissionName(2, "update_permission"),
  delete_permission_for_madinah: generatePermissionName(2, "delete_permission"),
  assign_permission_for_madinah: generatePermissionName(2, "assign_permission"),
  assign_system_for_madinah: generatePermissionName(2, "assign_system"),
  list_systems_for_madinah: generatePermissionName(2, "list_systems"),
  assign_role_for_madinah: generatePermissionName(2, "assign_role"),
  list_port_reception_cards_from_nusk_for_madina_for_madinah: generatePermissionName(2, "list_port_reception_cards_from_nusk"),
  manage_port_reception_cards_from_nusk_for_madina_for_madinah: generatePermissionName(2, "manage_port_reception_cards_from_nusk"),
  list_madina_arrival_bags_for_madinah: generatePermissionName(2, "list_madina_arrival_bags"),
  manage_madina_arrival_bags_for_madinah: generatePermissionName(2, "manage_madina_arrival_bags"),
  create_madina_arrival_reports_for_madinah: generatePermissionName(2, "create_madina_arrival_reports"),
  update_madina_arrival_reports_for_madinah: generatePermissionName(2, "update_madina_arrival_reports"),
  delete_madina_arrival_reports_for_madinah: generatePermissionName(2, "delete_madina_arrival_reports"),
  view_dashboard_summary_madina: generatePermissionName(2, "view_dashboard_summary_madina"),
  view_dashboard_sections_madina: generatePermissionName(2, "view_dashboard_sections_madina"),
  list_port_reception_cards_from_nusk_for_madina: generatePermissionName(2, "list_port_reception_cards_from_nusk"),
  manage_port_reception_cards_from_nusk_for_madina: generatePermissionName(2, "manage_port_reception_cards_from_nusk"),
  list_madina_arrival_bags: generatePermissionName(2, "list_madina_arrival_bags"),
  manage_madina_arrival_bags: generatePermissionName(2, "manage_madina_arrival_bags"),
  create_madina_arrival_bags: generatePermissionName(2, "create_madina_arrival_bags"),
  update_madina_arrival_bags: generatePermissionName(2, "update_madina_arrival_bags"),
  delete_madina_arrival_bags: generatePermissionName(2, "delete_madina_arrival_bags"),
  create_madina_arrival_reports: generatePermissionName(2, "create_madina_arrival_reports"),
  view_export_housing_contract_detail_report_for_madina: generatePermissionName(2, "view_export_housing_contract_detail_report"),
  view_export_food_contracts_report_for_madina: generatePermissionName(2, "view_export_food_contracts_report"),
  view_export_house_contract_campaigns_report_for_madina: generatePermissionName(2, "view_export_house_contract_campaigns_report"),
  view_export_housing_comprehensive_detail_report: generatePermissionName(2, "view_export_housing_comprehensive_detail_report"),
  view_export_housing_building_delegate_detail_report: generatePermissionName(2, "view_export_housing_building_delegate_detail_report"),
  view_export_housing_comprehensive_detail_report_for_madina: generatePermissionName(2, "view_export_housing_comprehensive_detail_report"),
  view_export_housing_building_delegate_detail_report_for_madina: generatePermissionName(2, "view_export_housing_building_delegate_detail_report"),
  update_madina_arrival_reports: generatePermissionName(2, "update_madina_arrival_reports"),
  delete_madina_arrival_reports: generatePermissionName(2, "delete_madina_arrival_reports"),
  list_madina_reception_manifests: generatePermissionName(2, "list_madina_reception_manifests"),
  view_madina_reception_manifest: generatePermissionName(2, "view_madina_reception_manifest"),
  update_madina_reception_manifest_bag_number: generatePermissionName(2, "update_madina_reception_manifest_bag_number"),
  set_madina_reception_manifest_arrive_time: generatePermissionName(2, "set_madina_reception_manifest_arrive_time"),
  cancel_madina_reception_manifest_arrival: generatePermissionName(2, "cancel_madina_reception_manifest_arrival"),
  list_madina_reception_manifest_pilgrims: generatePermissionName(2, "list_madina_reception_manifest_pilgrims"),
  accommodate_madina_reception_manifest_pilgrims: generatePermissionName(2, "accommodate_madina_reception_manifest_pilgrims"),
  list_madina_reception_manifest_bag_details: generatePermissionName(2, "list_madina_reception_manifest_bag_details"),
  create_madina_reception_manifest_bag_detail: generatePermissionName(2, "create_madina_reception_manifest_bag_detail"),
  update_madina_reception_manifest_bag_detail: generatePermissionName(2, "update_madina_reception_manifest_bag_detail"),
  delete_madina_reception_manifest_bag_detail: generatePermissionName(2, "delete_madina_reception_manifest_bag_detail"),
  list_madina_reception_tafweejs: generatePermissionName(2, "list_madina_reception_tafweejs"),
  update_madina_reception_tafweej_bag_number: generatePermissionName(2, "update_madina_reception_tafweej_bag_number"),
  set_madina_reception_tafweej_arrive_time: generatePermissionName(2, "set_madina_reception_tafweej_arrive_time"),
  cancel_madina_reception_tafweej_arrival: generatePermissionName(2, "cancel_madina_reception_tafweej_arrival"),
  list_madina_reception_tafweej_pilgrims: generatePermissionName(2, "list_madina_reception_tafweej_pilgrims"),
  accommodate_madina_reception_tafweej_pilgrims: generatePermissionName(2, "accommodate_madina_reception_tafweej_pilgrims"),
  list_madina_reception_tafweej_bag_details: generatePermissionName(2, "list_madina_reception_tafweej_bag_details"),
  delete_madina_reception_tafweej_bag_detail: generatePermissionName(2, "delete_madina_reception_tafweej_bag_detail"),
  view_pilgrim_report_not_coming_madina: generatePermissionName(2, "view_pilgrim_report_not_coming_madina"),
  view_pilgrim_report_not_accommodated_madina: generatePermissionName(2, "view_pilgrim_report_not_accommodated_madina"),
  list_madina_arrival_campaigns: generatePermissionName(2, "list_madina_arrival_campaigns"),
  view_madina_arrival_campaigns: generatePermissionName(2, "view_madina_arrival_campaigns"),
  create_madina_arrival_campaigns: generatePermissionName(2, "create_madina_arrival_campaigns"),
  update_madina_arrival_campaigns: generatePermissionName(2, "update_madina_arrival_campaigns"),
  delete_madina_arrival_campaigns: generatePermissionName(2, "delete_madina_arrival_campaigns"),
  list_madina_arrival_segments: generatePermissionName(2, "list_madina_arrival_segments"),
  view_madina_arrival_segments: generatePermissionName(2, "view_madina_arrival_segments"),
  create_madina_arrival_segments: generatePermissionName(2, "create_madina_arrival_segments"),
  update_madina_arrival_segments: generatePermissionName(2, "update_madina_arrival_segments"),
  delete_madina_arrival_segments: generatePermissionName(2, "delete_madina_arrival_segments"),
  list_madina_groups: generatePermissionName(2, "list_madina_groups"),
  view_madina_groups: generatePermissionName(2, "view_madina_groups"),
  create_madina_groups: generatePermissionName(2, "create_madina_groups"),
  update_madina_groups: generatePermissionName(2, "update_madina_groups"),
  delete_madina_groups: generatePermissionName(2, "delete_madina_groups"),
  list_madina_group_details: generatePermissionName(2, "list_madina_group_details"),
  view_madina_group_details: generatePermissionName(2, "view_madina_group_details"),
  create_madina_group_details: generatePermissionName(2, "create_madina_group_details"),
  update_madina_group_details: generatePermissionName(2, "update_madina_group_details"),
  delete_madina_group_details: generatePermissionName(2, "delete_madina_group_details"),
  assign_pilgrim_accommodation_madina: generatePermissionName(2, "assign_pilgrim_accommodation_madina"),
  cancel_pilgrim_accommodation_madina: generatePermissionName(2, "cancel_pilgrim_accommodation_madina"),
  view_accommodations_madina: generatePermissionName(2, "view_accommodations_madina"),
  list_madina_incident_reports: generatePermissionName(2, "list_madina_incident_reports"),
  create_madina_incident_reports: generatePermissionName(2, "create_madina_incident_reports"),
  update_madina_incident_reports: generatePermissionName(2, "update_madina_incident_reports"),
  delete_madina_incident_reports: generatePermissionName(2, "delete_madina_incident_reports"),
  view_madina_incident_reports_details: generatePermissionName(2, "view_madina_incident_reports_details"),
  search_pilgrims_for_madina_incident_reports: generatePermissionName(2, "search_pilgrims_incident_reports"),
  view_export_madina_incident_reports_report: generatePermissionName(2, "view_export_madina_incident_reports_report"),
  madina_view_export_incident_reports: generatePermissionName(2, "madina_view_export_incident_reports"),
  view_export_arrival_campaign_segments_report: generatePermissionName(2, "view_export_madina_arrival_campaign_segments_report"),
  view_export_group_details_report: generatePermissionName(2, "view_export_madina_group_details_report"),
  view_export_housed_arrivals_service_center_distribution_report: generatePermissionName(2, "view_export_madina_housed_arrivals_service_center_distribution_report"),
  view_export_campaign_statement_report: generatePermissionName(2, "view_export_madina_campaign_statement_report"),
  view_export_group_statement_report: generatePermissionName(2, "view_export_madina_group_statement_report"),
  list_nusuk_cards_batchs: generatePermissionName(2, "list_nusuk_cards_batchs_madina"),
  view_nusuk_cards_batchs: generatePermissionName(2, "view_nusuk_cards_batchs_madina"),
  create_nusuk_cards_batchs: generatePermissionName(2, "create_nusuk_cards_batchs_madina"),
  update_nusuk_cards_batchs: generatePermissionName(2, "update_nusuk_cards_batchs_madina"),
  delete_nusuk_cards_batchs: generatePermissionName(2, "delete_nusuk_cards_batchs_madina"),
  change_delivery_status_nusuk_cards_batchs: generatePermissionName(2, "change_delivery_status_nusuk_cards_batchs_madina"),
  list_nusuk_cards_batch_returns: generatePermissionName(2, "list_nusuk_cards_batch_returns_madina"),
  create_nusuk_cards_batch_returns: generatePermissionName(2, "create_nusuk_cards_batch_returns_madina"),
  update_nusuk_cards_batch_returns: generatePermissionName(2, "update_nusuk_cards_batch_returns_madina"),
  delete_nusuk_cards_batch_returns: generatePermissionName(2, "delete_nusuk_cards_batch_returns_madina"),
  view_export_nusuk_cards_batch_report: generatePermissionName(2, "view_export_nusuk_cards_batch_report_madina"),
  list_nusuk_cards_batchs_incident_reports: generatePermissionName(2, "list_nusuk_cards_batchs_incident_reports_madina"),
  resolve_nusuk_cards_batchs_incident_reports: generatePermissionName(2, "resolve_nusuk_cards_batchs_incident_reports_madina"),
};

export const SEASONAL_HR_PERMISSIONS = {
  list_users_for_seasonal_hr: "list_users",
  create_user_for_seasonal_hr: "create_user",
  update_user_for_seasonal_hr: "update_user",
  delete_user_for_seasonal_hr: "delete_user",
  reset_user_password_for_seasonal_hr: "reset_user_password",
  update_user_status_for_seasonal_hr: "update_user_status",
  upload_user_profile_image_for_seasonal_hr: "upload_user_profile_image",
  assign_user_permissions_for_seasonal_hr: "assign_user_permissions",
  assign_user_groups_for_seasonal_hr: "assign_user_groups",
  list_groups_for_seasonal_hr: "list_groups",
  create_group_for_seasonal_hr: "create_group",
  update_group_for_seasonal_hr: "update_group",
  delete_group_for_seasonal_hr: "delete_group",
  assign_group_for_seasonal_hr: "assign_group",
  assign_group_permissions_for_seasonal_hr: "assign_group_permissions",
  list_permissions_for_seasonal_hr: "list_permissions",
  create_permission_for_seasonal_hr: "create_permission",
  update_permission_for_seasonal_hr: "update_permission",
  delete_permission_for_seasonal_hr: "delete_permission",
  assign_permission_for_seasonal_hr: "assign_permission",
  assign_system_for_seasonal_hr: "assign_system",
  list_systems_for_seasonal_hr: "list_systems",
  assign_role_for_seasonal_hr: "assign_role",
  view_dashboard_summary_hr: "view_dashboard_summary_hr",
};
export const SEASONAL_HR_PERMISSIONS_FULL_NAMES = {
  list_users_for_seasonal_hr: generatePermissionName(3, "list_users") ,
  create_user_for_seasonal_hr: generatePermissionName(3, "create_user"),
  update_user_for_seasonal_hr: generatePermissionName(3, "update_user"),
  delete_user_for_seasonal_hr: generatePermissionName(3, "delete_user"),
  reset_user_password_for_seasonal_hr: generatePermissionName(3, "reset_user_password"),
  update_user_status_for_seasonal_hr: generatePermissionName(3, "update_user_status"),
  upload_user_profile_image_for_seasonal_hr: generatePermissionName(3, "upload_user_profile_image"),
  assign_user_permissions_for_seasonal_hr: generatePermissionName(3, "assign_user_permissions"),
  assign_user_groups_for_seasonal_hr: generatePermissionName(3, "assign_user_groups"),
  list_groups_for_seasonal_hr: generatePermissionName(3, "list_groups"),
  create_group_for_seasonal_hr: generatePermissionName(3, "create_group"),
  update_group_for_seasonal_hr: generatePermissionName(3, "update_group"),
  delete_group_for_seasonal_hr: generatePermissionName(3, "delete_group"),
  assign_group_for_seasonal_hr: generatePermissionName(3, "assign_group"),
  assign_group_permissions_for_seasonal_hr: generatePermissionName(3, "assign_group_permissions"),
  list_permissions_for_seasonal_hr: generatePermissionName(3, "list_permissions"),
  create_permission_for_seasonal_hr: generatePermissionName(3, "create_permission"),
  update_permission_for_seasonal_hr: generatePermissionName(3, "update_permission"),
  delete_permission_for_seasonal_hr: generatePermissionName(3, "delete_permission"),
  assign_permission_for_seasonal_hr: generatePermissionName(3, "assign_permission"),
  assign_system_for_seasonal_hr: generatePermissionName(3, "assign_system"),
  list_systems_for_seasonal_hr: generatePermissionName(3, "list_systems"),
  assign_role_for_seasonal_hr: generatePermissionName(3, "assign_role"),
  view_dashboard_summary_hr: generatePermissionName(3, "view_dashboard_summary_hr"),
};

export const USER_MANAGEMENT_PERMISSIONS = {
  list_users_for_user_management: "list_users",
  create_user_for_user_management: "create_user",
  update_user_for_user_management: "update_user",
  delete_user_for_user_management: "delete_user",
  reset_user_password_for_user_management: "reset_user_password",
  update_user_status_for_user_management: "update_user_status",
  upload_user_profile_image_for_user_management: "upload_user_profile_image",
  assign_user_permissions_for_user_management: "assign_user_permissions",
  assign_user_groups_for_user_management: "assign_user_groups",
  list_groups_for_user_management: "list_groups",
  create_group_for_user_management: "create_group",
  update_group_for_user_management: "update_group",
  delete_group_for_user_management: "delete_group",
  assign_group_for_user_management: "assign_group",
  assign_group_permissions_for_user_management: "assign_group_permissions",
  list_permissions_for_user_management: "list_permissions",
  create_permission_for_user_management: "create_permission",
  update_permission_for_user_management: "update_permission",
  delete_permission_for_user_management: "delete_permission",
  assign_permission_for_user_management: "assign_permission",
  assign_system_for_user_management: "assign_system",
  list_systems_for_user_management: "list_systems",
  assign_role_for_user_management: "assign_role",
  view_dashboard_summary_user_management: "view_dashboard_summary_user_management",
};

export const USER_MANAGEMENT_PERMISSIONS_FULL_NAMES = {
  list_users_for_user_management: generatePermissionName(4, "list_users"),
  create_user_for_user_management: generatePermissionName(4, "create_user"),
  update_user_for_user_management: generatePermissionName(4, "update_user"),
  delete_user_for_user_management: generatePermissionName(4, "delete_user"),
  reset_user_password_for_user_management: generatePermissionName(4, "reset_user_password"),
  update_user_status_for_user_management: generatePermissionName(4, "update_user_status"),
  upload_user_profile_image_for_user_management: generatePermissionName(4, "upload_user_profile_image"),
  assign_user_permissions_for_user_management: generatePermissionName(4, "assign_user_permissions"),
  assign_user_groups_for_user_management: generatePermissionName(4, "assign_user_groups"),
  list_groups_for_user_management: generatePermissionName(4, "list_groups"),
  create_group_for_user_management: generatePermissionName(4, "create_group"),
  update_group_for_user_management: generatePermissionName(4, "update_group"),
  delete_group_for_user_management: generatePermissionName(4, "delete_group"),
  assign_group_for_user_management: generatePermissionName(4, "assign_group"),
  assign_group_permissions_for_user_management: generatePermissionName(4, "assign_group_permissions"),
  list_permissions_for_user_management: generatePermissionName(4, "list_permissions"),
  create_permission_for_user_management: generatePermissionName(4, "create_permission"),
  update_permission_for_user_management: generatePermissionName(4, "update_permission"),
  delete_permission_for_user_management: generatePermissionName(4, "delete_permission"),
  assign_permission_for_user_management: generatePermissionName(4, "assign_permission"),
  assign_system_for_user_management: generatePermissionName(4, "assign_system"),
  list_systems_for_user_management: generatePermissionName(4, "list_systems"),
  assign_role_for_user_management: generatePermissionName(4, "assign_role"),
  view_dashboard_summary_user_management: generatePermissionName(4, "view_dashboard_summary_user_management"),
};

